import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import testimonials from "../data/testimonials";

const ValouseTestimonials = () => {
  return (
    <div className="min-h-screen bg-[#4B3329] flex flex-col">
      {/* Header */}
      <header className="px-6 pt-8 pb-4">
        <div className="max-w-3xl mx-auto">
          <Link 
            to="/valouse#temoignages"
            className="inline-flex items-center gap-2 text-[#F3E5CF] hover:text-[#C5A059] transition-colors"
            data-testid="back-to-valouse"
          >
            <span className="text-sm tracking-wide">← Retour à COCON Valouse</span>
          </Link>
        </div>
      </header>

      {/* Title + Intro */}
      <section className="px-6 py-12">
        <div className="max-w-3xl mx-auto text-center animate-fade-in-up">
          <h1 className="font-serif text-2xl md:text-4xl text-[#F3E5CF] leading-snug space-y-2">
            <span className="block">Ce qui suit n'est pas un avis.</span>
            <span className="block italic">C'est un écho.</span>
            <span className="block mt-4">Prends ce qui résonne.</span>
            <span className="block mt-6 text-lg md:text-2xl text-[#E8D2B5]/80 tracking-wide">Laisse le reste...</span>
          </h1>
        </div>
      </section>

      {/* Vidéo */}
      <section className="px-6 pb-8">
        <div className="max-w-3xl mx-auto text-center">
          <div className="rounded-2xl overflow-hidden shadow-sacred bg-[#3F2A24] border border-[#E8D2B5]/40">
            <video controls className="w-full h-full max-h-[480px] object-cover">
              <source src="https://customer-assets.emergentagent.com/job_react-revamp-2/artifacts/99bcg5wx_Cocon_Jour05.MOV" type="video/quicktime" />
              <source src="https://customer-assets.emergentagent.com/job_react-revamp-2/artifacts/99bcg5wx_Cocon_Jour05.MOV" type="video/mp4" />
              Votre navigateur ne supporte pas la lecture de cette vidéo.
            </video>
          </div>
        </div>
      </section>

      {/* Phrase d'entrée */}
      <section className="px-6 py-14 sm:py-20" data-testid="post-video-intro">
        <div className="max-w-xl mx-auto text-center space-y-6">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#C5A059]">Paroles vivantes</p>
          <div className="w-12 h-[1px] bg-[#C5A059]/40 mx-auto" />
          <div className="space-y-5 font-serif text-sm sm:text-base text-[#F3E5CF]/70 leading-[2.2]">
            <p>Certaines expériences sont difficiles à expliquer.</p>
            <p>Celles et ceux qui ont traversé COCON<br />ont simplement tenté de poser quelques mots.</p>
            <p className="pt-2">Pas pour convaincre.</p>
            <p className="italic">Mais pour partager ce qui s'est réellement vécu.</p>
          </div>
        </div>
      </section>

      {/* Témoignage phare — Théo */}
      <section className="px-6 pb-12" data-testid="featured-testimonial">
        <div className="max-w-3xl mx-auto">
          <article className="bg-[#F3E5CF] rounded-2xl p-8 sm:p-10 md:p-12">
            <div className="flex flex-col items-center text-center mb-10">
              <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-full overflow-hidden border-2 border-[#C5A059] mb-4">
                <img src="https://customer-assets.emergentagent.com/job_85e818bc-12c2-403d-b0d1-561acf076822/artifacts/yuz13b4x_DSC07812.jpg" alt="Théo" className="w-full h-full object-cover" />
              </div>
              <p className="font-serif text-xl text-[#3F2A24]" data-testid="featured-testimonial-name">
                Théo <span className="text-[#3F2A24]/40 font-sans text-sm">·</span> <span className="text-sm tracking-[0.1em] text-[#3F2A24]/50 font-sans">Annecy</span>
              </p>
            </div>
            <div className="max-w-xl mx-auto space-y-8" data-testid="featured-testimonial-text">
              <div className="space-y-4">
                <p className="text-[10px] tracking-[0.2em] uppercase text-[#C5A059] font-medium">Tu peux décrire ta semaine en un mot ?</p>
                <div className="space-y-4 text-sm sm:text-base text-[#3F2A24]/80 leading-[2]">
                  <p className="font-serif text-lg text-[#3F2A24] italic">Paix.</p>
                  <p>Je suis venu avec l'intention d'être plus en paix à l'intérieur de moi-même.</p>
                  <p>Grâce aux différents ateliers proposés par les coconeuses, j'ai pu aller plus loin, plus en profondeur.</p>
                  <p>Ça m'a permis de me rapprocher de cette paix intérieure… et de pouvoir ensuite la retranscrire à l'extérieur.</p>
                  <p className="italic text-[#3F2A24]/60">Et ça, c'est précieux.</p>
                </div>
              </div>
              <div className="w-10 h-[1px] bg-[#C5A059]/30 mx-auto" />
              <div className="space-y-4">
                <p className="text-[10px] tracking-[0.2em] uppercase text-[#C5A059] font-medium">Quel moment t'a le plus marqué ?</p>
                <div className="space-y-4 text-sm sm:text-base text-[#3F2A24]/80 leading-[2]">
                  <p className="font-serif text-lg text-[#3F2A24] italic">L'atelier de chant.</p>
                  <p>C'est devenu très chamanique. On était un groupe très soudé et on est allés loin dans nos profondeurs. J'ai pu libérer beaucoup de choses.</p>
                  <p className="italic text-[#3F2A24]/60">J'ai pleuré… pour la quatrième fois de ma vie.</p>
                </div>
              </div>
              <div className="w-10 h-[1px] bg-[#C5A059]/30 mx-auto" />
              <div className="space-y-4">
                <p className="text-[10px] tracking-[0.2em] uppercase text-[#C5A059] font-medium">Et ton atelier préféré ?</p>
                <div className="space-y-4 text-sm sm:text-base text-[#3F2A24]/80 leading-[2]">
                  <p>Celui de Deborah, sur la compréhension du mental.</p>
                  <p>Il m'a vraiment aidé à mettre de la conscience sur beaucoup de choses.</p>
                </div>
              </div>
              <div className="w-10 h-[1px] bg-[#C5A059]/30 mx-auto" />
              <div className="space-y-4">
                <p className="text-[10px] tracking-[0.2em] uppercase text-[#C5A059] font-medium">Si tu devais résumer ta semaine ?</p>
                <div className="space-y-4 text-sm sm:text-base text-[#3F2A24]/80 leading-[2]">
                  <p>Je dirais :</p>
                  <p className="font-serif text-lg text-[#3F2A24] italic leading-[2.4]">paix,<br />harmonie,<br />et bienveillance.</p>
                  <p>Et cette harmonie du groupe, elle vient d'abord de Jeinar.</p>
                  <p>Elle a su s'entourer de belles personnes pour accompagner cette retraite. J'ai vu un peu les coulisses, les échanges en amont… et ça se ressent.</p>
                  <p className="italic text-[#3F2A24]/60">Grâce à leur harmonie, tout le groupe a trouvé la sienne.</p>
                  <p>Et ça, quand on est vingt personnes, ce n'est pas si évident.</p>
                  <p className="pt-2">Moi, j'ai adoré cette semaine.</p>
                  <p className="font-serif text-[#3F2A24] italic">Vraiment.</p>
                  <p className="italic text-[#C5A059]">Vivement la prochaine.</p>
                </div>
              </div>
            </div>
          </article>
        </div>
      </section>

      {/* Phrase de respiration */}
      <section className="px-6 py-14 sm:py-20" data-testid="post-featured-breath">
        <div className="max-w-xl mx-auto text-center space-y-6">
          <div className="space-y-5 font-serif text-sm sm:text-base text-[#F3E5CF]/60 leading-[2.2]">
            <p>Chaque témoignage est différent.</p>
            <p>Mais tou·te·s racontent la même chose :</p>
            <p className="italic text-[#F3E5CF]/80">un moment où quelque chose en soi<br />se remet à bouger.</p>
          </div>
        </div>
      </section>

      {/* Grille — Progression émotionnelle */}
      <section id="temoignages" className="px-6 pb-16 flex-1">
        <div className="max-w-5xl mx-auto">
          <div className="grid gap-6 md:grid-cols-4">
            {testimonials.map((t, index) =>
              t.transition ? (
                <div key={`transition-${index}`} className="md:col-span-4 py-8 text-center">
                  <p className="font-serif text-sm sm:text-base text-[#F3E5CF]/50 italic leading-[2.2] whitespace-pre-line">
                    {t.transition}
                  </p>
                </div>
              ) : (
                <article
                  key={`vt-${t.name || index}`}
                  className="group relative card-sacred p-5 text-sm text-[#3F2A24] leading-relaxed cursor-pointer bg-[#F3E5CF]"
                  data-testid={`testimonial-card-${index}`}
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-9 h-9 rounded-full overflow-hidden border-2 border-[#C5A059]/50 flex-shrink-0">
                      <img src={t.photo} alt={t.name} className="w-full h-full object-cover" />
                    </div>
                    <span className="font-semibold text-xs tracking-wide text-[#3F2A24]">
                      {t.name}{t.city ? ` · ${t.city}` : ''}
                    </span>
                  </div>
                  <div className="relative overflow-hidden max-h-20 group-hover:max-h-[1000px] transition-all duration-500">
                    <p className="text-[#3F2A24]/85">{t.text}</p>
                    <div className="pointer-events-none absolute inset-x-0 bottom-0 h-12 bg-gradient-to-t from-[#F3E5CF] via-transparent opacity-80 group-hover:opacity-0 transition-opacity duration-500" />
                  </div>
                </article>
              )
            )}
          </div>
        </div>
      </section>

      {/* Lien retour bas de page */}
      <div className="px-6 pb-8">
        <div className="max-w-3xl mx-auto">
          <Link to="/valouse#temoignages" className="inline-flex items-center gap-2 text-[#F3E5CF] hover:text-[#C5A059] transition-colors" data-testid="back-to-valouse-bottom">
            <span className="text-sm tracking-wide">← Retour à COCON Valouse</span>
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ValouseTestimonials;
